// extracted by mini-css-extract-plugin
export var text = "_2s-0";